import { ReactElement, ReactNode } from 'react';
import { ThemeProvider } from 'styled-components';

import GlobalStyle from '../GlobalStyle';
import { CalmTheme, D2CTheme, PortalTheme, SleepTheme } from '../ThemeProvider';

const DesignSystemProvider = ({
	theme,
	children,
}: {
	theme: typeof CalmTheme | typeof PortalTheme | typeof D2CTheme | typeof SleepTheme;
	children?: ReactNode;
}): ReactElement => {
	return (
		<>
			<ThemeProvider theme={theme}>
				<GlobalStyle />
				{children}
			</ThemeProvider>
		</>
	);
};

export default DesignSystemProvider;
